module.exports = __webpack_public_path__ + "static/img/cdms_logo_test.5e40666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cdms_logo_test.png
// module id = BtzI
// module chunks = 109